import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import { ChangeEvent } from "react";
import { SideSheetFieldPropsBase } from "../side-sheet/SideSheet";

export type SideSheetRadioGroupRadioButton = {
    label: string;
    ariaLabel?: string | null;
    value: number;
    helperText?: string;
    disabled?: boolean
};

export type SideSheetRadioGroupProps = {
    radioButtons: Array<SideSheetRadioGroupRadioButton>;
    value: number;
    onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
    row?: boolean;
} & SideSheetFieldPropsBase;

export default function SideSheetRadioGroup({
    id,
    testId,
    label,
    ariaLabel,
    helperText,
    sx,
    disabled,
    value,
    radioButtons,
    onChange,
    row
 }: SideSheetRadioGroupProps) {

    return (
        <FormControl
            component="fieldset"
            aria-label={ariaLabel}
            sx={{
                marginTop: 0,
                ...sx
            }}>
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup
                id={id}
                data-testid={testId}
                value={value ?? -1}
                onChange={onChange}
                row={row}
            >
                {radioButtons.map((item, index) => (
                    <FormControl key={index}>
                        <FormControlLabel
                            sx={{
                                marginTop: 0,
                                ...sx
                            }}
                            value={item.value}
                            control={
                                <Radio
                                    disabled={disabled || item.disabled}
                                    slotProps={{
                                        input: { "aria-label": item.ariaLabel ?? undefined }
                                    }}
                                />}
                            label={item.label} />

                        {item.helperText &&
                            <FormHelperText >{item.helperText}</FormHelperText>
                        }
                    </FormControl>
                ))}
            </RadioGroup>
            {helperText &&
                <FormHelperText>{helperText}</FormHelperText>
            }
        </FormControl>
    );
}